export const voucherPaymentFilter = state => state.voucherPayment.filter;
